var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommit = function SvgCommit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.04 63.72"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.04,
    y: 6.72,
    width: 61,
    height: 57,
    rx: 8.1,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2,46.33V10.87C2,5.97,5.97,2,10.87,2h5.91c4.9,0,8.87,3.97,8.87,8.87v35.46c0,4.9-3.97,8.87-8.87,8.87h-5.91c-4.9,0-8.87-3.97-8.87-8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.37,2h5.91c6.53,0,11.82,5.29,11.82,11.82v29.55c0,6.53-5.29,11.82-11.82,11.82h-5.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.64,28.6h23.64M49.28,28.6l-8.87-8.87M49.28,28.6l-8.87,8.87"
  }))));
};
export default SvgCommit;